module.exports = "/_next/static/images/49875a992116f197d03b0fbb98bc5322-device-frame@1x.png.webp";